
import { Box, Button, FormControl, FormHelperText, IconButton, Modal, TextField, Typography, styled, useMediaQuery } from "@mui/material"
import PhoneIcon from "../../images/phone_verify.svg"
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import { MuiOtpInput } from "mui-one-time-password-input";
import { useEffect, useState } from "react";
import { filterNonDigits, phoneNumberFormatter } from "../../libs/utils";

export const StyledTextField = styled(TextField)({
    width: "100%", 
    backgroundColor: "white",
    fontSize: "16px"
})

const PhoneVerifyModal = ({ show, setShow, phone, setRegistrationForm, phoneError, handlePhoneBlur }) => {
    const [otp, setOtp] = useState('')
    const [resendDisabled, setResendDisabled] = useState(false);
    const [countdown, setCountdown] = useState(60);

    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    useEffect(() => {
        if (resendDisabled) {
          startResendTimer()
        }
        return () => {
          setResendDisabled(false)
          setCountdown(60)
        }
      }, [resendDisabled])

      const startResendTimer = () => {
        setResendDisabled(true)
        let timeLeft = 60
        const timer = setInterval(() => {
          timeLeft--
          setCountdown(timeLeft)
          if (timeLeft === 0) {
            setResendDisabled(false)
            clearInterval(timer)
          }
        }, 1000)
      }

    const handleOtpChange = (val) => {
        const filteredVal = filterNonDigits(val)
        setOtp(filteredVal)
      }

    const resend = async () => {
        // const inputPayload = {
        //   affiliateCode,
        //   email: workEmail,
        // }
        // await axios.post(`${apiURL}`, {
        //   ...inputPayload,
        //   prsCode: '3702F702',
        // })
        setResendDisabled(true)
        setCountdown(60)
      }

      const matchVerificationCode = () => {
        // const inputPayload = {
        //   affiliateCode,
        //   email: workEmail,
        //   verification_code: Number(otp),
        // }
        // dispatch(verifyEmailStepTwo(inputPayload))
        // setMessageToggle(!messageToggle)
      }

    return <Modal
        open={show}
        onClose={() => setShow(false)}
    >

        <Box
            sx={{
                pt: { lg: '52px', md: '52px', sm: '39px', xs: '24px' },
                pr: { lg: '52px', md: '52px', sm: '39px', xs: '16px' },
                pb: { lg: '52px', md: '52px', sm: '39px', xs: '24px' },
                pl: { lg: '52px', md: '52px', sm: '39px', xs: '16px' },
                width: { lg: '502px', md: '502px', sm: '502px', xs: '343px' },
                borderRadius: "10px",
                backgroundColor:"#E8EBF1",
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                // padding: '15px',
            }}
        >
            <Box width={'100%'} display={"flex"} justifyContent={"flex-end"}>
                <IconButton  onClick={() => setShow(false)}>
                    <CloseIcon sx={{fontSize:"20px"}}/>
                </IconButton>
            </Box>
            <img
                src={PhoneIcon}
                alt="phone-verify"
                width={isMobile ? "50px" : "60px"}
                style={{marginBottom: "0.8rem"}}
            />
            <Typography variant="h1" mb={"0.7rem"} fontSize={{md:"36px", sm: '28px', xs: '24px'}} textAlign={"center"}>
                Verify your work phone number
            </Typography>
            <Typography fontSize={{md:"16px", sm: '16px', xs: '14px'}} mb={4} color="#64768C" textAlign={"center"} px={"2rem"}>
                Enter the 6 digit code sent to your phone. By verifying your phone number, you consent to receive SMS to verify your identity. There may be a charge depending on the carrier.
            </Typography>
            <Box mb={3} width={{md: '50%', sm: '80%', xs: '100%'}} flex flexDirection={'column'} gap={"10px"}>
                <FormControl fullWidth>
                    <StyledTextField
                        InputLabelProps={{
                            shrink: true,
                            sx: {
                            '&.MuiInputLabel-shrink': {
                                backgroundColor: '#F5F7FF',
                            },
                            },
                        }}
                        placeholder="ex. 000-000-0000"
                        className="white-box"
                        label="Work Phone Number"
                        value={phone}
                        name="workAgentPhone"
                        type="number"
                        onBlur={e => handlePhoneBlur(e)}
                        error={phoneError}
                        onChange={(e) => setRegistrationForm(e)}
                    />
                </FormControl>
                {phoneError && <FormHelperText>
                    <div style={{ display: 'flex', alignItems: "center", gap: "2px" }}>
                        <ErrorIcon sx={{ fontSize: '0.8rem !important', color:"#CA303A" }} />
                        <Typography fontSize={'12px'} color="#CA303A">Please enter a valid phone number</Typography>
                    </div>
                </FormHelperText>}
            </Box>
            <Box width={{md: '50%', sm: '80%', xs: '100%'}}>
                <Typography variant="caption">Verification Code</Typography>
                <MuiOtpInput
                    inputMode="numeric"
                    value={otp}
                    length={6}
                    onChange={handleOtpChange}
                    TextFieldsProps={{ variant: 'standard' }}
                    la
                    sx={{width:"100%"}}
                    
                ></MuiOtpInput>
            </Box>
            <Typography color="#36414E" fontSize={'16px'} align="center" padding="32px 0px">
                Didn't receive the code?
                <Button onClick={resend} disabled={resendDisabled} sx={{textTransform:"none"}}>
                {resendDisabled ? `Resend in ${countdown}s` : 'Resend'}
                </Button>
            </Typography>
            <Button sx={{
                 textTransform: 'none',
                 width: { lg: '20%', md: '50%', sm: '80%', xs: '100%' },
                 height: '45px',
                 backgroundColor: '#3C4FB9',
                 color: 'white',
                 borderRadius: '100px',
                 mb: '40px',
                 mt: '10px',
                 '&:hover': {
                   backgroundColor: '#9BA5DF',
                   color: '#36414E',
                 },
                 '&:disabled': {
                   backgroundColor: '#C4CAF1',
                   color: 'white',
                   textTransform: 'none',
                 },
            }} onClick={matchVerificationCode} disabled={otp.length < 6}>
                Verify
            </Button>
        </Box>
    </Modal>
}

export default PhoneVerifyModal;